import { ReactElement } from 'react'
import styled from '@emotion/styled'
import _ from 'lodash'

type DividerProps = {
  height: number | string
  color?: string
}

const Divider = styled.div<DividerProps>`
  width: 1px;
  height: ${({ height }) => (_.isString(height) ? height : `${height}px`)};
  background-color: ${({ color }) => color || '#e4e4e4'};
`

const VerticalDivider = ({
  className,
  height,
  color,
}: DividerProps & {
  className?: string
}): ReactElement => (
  <Divider className={className} height={height} color={color} />
)

export default VerticalDivider
